'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventsNoble = undefined;
exports.getLeastFutureEventByMasterId = getLeastFutureEventByMasterId;
exports.getMostRecentPastEventByMasterId = getMostRecentPastEventByMasterId;
exports.getLatestEventByMasterId = getLatestEventByMasterId;
exports.getAllEventsByMasterId = getAllEventsByMasterId;
exports.getEventByEventId = getEventByEventId;
exports.getEventCourseIds = getEventCourseIds;
exports.getRegisteredAthletesForEventCallback = getRegisteredAthletesForEventCallback;
exports.getRegisteredAthletesForEvent = getRegisteredAthletesForEvent;
exports.getRegistrationOptions = getRegistrationOptions;
exports.getUnhiddenRegOptions = getUnhiddenRegOptions;

var _rx = require('rx');

var _bastetjs = require('bastetjs');

var _Configure = require('../Configure');

var _ErosApi = require('../apis/ErosApi');

var _FetchPeon = require('../peons/FetchPeon');

var _RetryHelper = require('./helpers/RetryHelper');

var _distanceConverter = require('../distanceConverter');

var _distanceConverter2 = _interopRequireDefault(_distanceConverter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getEventFields(includeMasterId) {
  var baseFields = ['id', // CT Live event ID (usually NULL, for Athlinks events)
  'name', 'master_name', 'description', 'extended_description', 'start_epoch', 'end_epoch', 'image_name', 'athlinks_id', 'location.id', 'location.city', 'location.country_id', 'location.region_id', 'location.region_name', 'location.country', 'location.latitude', 'location.longitude', 'location.time_zone', 'organization.id', 'organization.name', 'organization.email', 'organization.url', 'timer.id', 'timer.name', 'timer.email', 'timer.url', 'event_type', 'site_uri', 'facebook_url', 'twitter_handle', 'instagram_handle', 'third_party_reg_link', 'has_hero_image', 'is_published_athlinks', 'wants_photo_purchasing', 'entry_photo_price', 'photo_price', 'photo_purchasing_help', 'photo_service_type', 'photo_service_name', 'photo_service_url'];

  // Only event/athlinks records have a athlinks_master_id field.
  return includeMasterId ? baseFields.concat('athlinks_master_id') : baseFields;
}

function _assembleEventRecords(msg, hits) {
  if ('isLoading' in msg && msg.isLoading) {
    return [msg];
  }

  return hits.map(function (hit) {
    return _bastetjs.utils.entityDecoder.decode({
      event: {
        id: parseInt(hit.id || 0),
        name: hit.name,
        masterName: hit.master_name,
        description: hit.description,
        extendedDescription: hit.extended_description,
        endEpoch: hit.end_epoch,
        startEpoch: hit.start_epoch,
        imageName: hit.image_name,
        city: hit.location ? hit.location.city : '',
        region: hit.location ? hit.location.region_name : '',
        regionId: hit.location ? hit.location.region_id : '',
        country: hit.location ? hit.location.country : '',
        countryId: hit.location ? hit.location.country_id : '',
        latitude: hit.location ? hit.location.latitude : null,
        longitude: hit.location ? hit.location.longitude : null,
        timeZone: hit.location ? hit.location.time_zone : '',
        organizationName: hit.organization ? hit.organization.name : '',
        organizationEmail: hit.organization ? hit.organization.email : '',
        organizationUrl: hit.organization ? hit.organization.url : '',
        timerName: hit.timer ? hit.timer.name : '',
        timerEmail: hit.timer ? hit.timer.email : '',
        timerUrl: hit.timer ? hit.timer.url : '',
        athlinksId: hit.athlinks_id,
        masterId: hit.athlinks_master_id || 0,
        eventType: hit.event_type,
        siteUri: hit.site_uri,
        facebookUrl: hit.facebook_url,
        twitterHandle: hit.twitter_handle,
        instagramHandle: hit.instagram_handle,
        thirdPartyRegLink: hit.third_party_reg_link,
        hasHeroImage: hit.has_hero_image,
        isPublished: hit.is_published_athlinks,
        wantsPhotoPurchasing: !!hit.wants_photo_purchasing,
        entryPhotoPrice: hit.entry_photo_price,
        photoPrice: hit.photo_price,
        photoPurchasingHelp: hit.photo_purchasing_help,
        photoServiceType: hit.photo_service_type,
        photoServiceName: hit.photo_service_name,
        photoServiceUrl: hit.photo_service_url
      }
    });
  });
}

function _eventsByMasterIdQuery(masterId, size) {
  return {
    _source: _getEventFields(true),
    size: size || 1,
    sort: [{ start_epoch: { order: 'desc' } }, { athlinks_id: { order: 'desc' } }],
    query: { term: { athlinks_master_id: masterId } }
  };
}

function getLeastFutureEventByMasterId(_ref) {
  var masterId = _ref.masterId;

  var query = _eventsByMasterIdQuery(masterId, 100);
  return _ErosApi.ErosApi.query('GetLeastFutureEventByMasterId', 'event/athlinks/_search', query).map(function (msg) {
    function getLeastFutureEvent(head, tail, now) {
      return !tail || tail.length < 1 || tail[0].event.startEpoch < now ? head : getLeastFutureEvent(tail[0], tail.slice(1), now);
    }

    var list = _assembleEventRecords(msg, msg.hits ? msg.hits : []);
    return list.length > 1 ? getLeastFutureEvent(list[0], list.slice(1), new Date().getTime() / 1000) : list.length > 0 ? list[0] : _assembleEventRecords(msg, [{}])[0];
  });
}

function getMostRecentPastEventByMasterId(_ref2) {
  var masterId = _ref2.masterId;

  var query = _eventsByMasterIdQuery(masterId, 20);
  var now = new Date().getTime() / 1000;

  return _ErosApi.ErosApi.query('GetMostRecentPastEventByMasterId', 'event/athlinks/_search', query).map(function (msg) {
    var past = _assembleEventRecords(msg, msg.hits ? msg.hits : []).filter(function (_) {
      return _.event.startEpoch < now;
    });
    return past.shift() || _assembleEventRecords(msg, [{}])[0];
  });
}

function getLatestEventByMasterId(_ref3) {
  var masterId = _ref3.masterId;

  var query = _eventsByMasterIdQuery(masterId, 1);
  return _ErosApi.ErosApi.query('GetLatestEventByMasterId', 'event/athlinks/_search', query).map(function (msg) {
    return _assembleEventRecords(msg, [msg.hits && msg.hits[0] || {}])[0];
  });
}

function getAllEventsByMasterId(_ref4) {
  var masterId = _ref4.masterId;

  var query = _eventsByMasterIdQuery(masterId, 500);
  return _ErosApi.ErosApi.query('GetAllEventsByMasterId', 'event/athlinks/_search', query).map(function (msg) {
    return _assembleEventRecords(msg, msg.hits ? msg.hits : []);
  });
}

function getEventByEventId(_ref5) {
  var eventId = _ref5.eventId;

  var query = {
    _source: _getEventFields(true),
    query: { match: { athlinks_id: eventId } }
  };
  return _ErosApi.ErosApi.query('getEventByEventId', 'event/athlinks/_search', query).map(function (msg) {
    return _assembleEventRecords(msg, [msg.hits && msg.hits[0] || {}])[0];
  });
}

// It's wonky that we're using an API route that appears to be for getting a
// single race (right down to accepting a 'raceId' parameter), to get all of the
// races for a particular event, but that's the way the API is.
// valid nextRaceDate example: '2016-02-15T07:00:00'
/**
 * @param {int} raceId
 * @param {string} nextRaceDate Ex: '2016-02-15T07:00:00'
 * @param {object|null} timeoutOpts Optional doFetch timeout object.
 * @see FetchPeon.doFetch.
 */
function getEventCourseIds(_ref6) {
  var raceId = _ref6.raceId;
  var nextRaceDate = _ref6.nextRaceDate;
  var timeoutOpts = _ref6.timeoutOpts;

  var host = (0, _Configure.getValue)('ATHLINKS_API_HOST');
  return (0, _FetchPeon.doFetch)(host + '/Events/Race/Api/' + raceId, null, true, timeoutOpts).map(function (race) {
    var eventRaces = race.Result && race.Result.MasterEvent && race.Result.MasterEvent.EventRaces ? race.Result.MasterEvent.EventRaces : [];
    var matches = eventRaces.filter(function (_) {
      return _.RaceDate == nextRaceDate;
    });
    var courses = matches.length == 1 ? matches[0].EventCourses : [];
    return courses.map(function (_) {
      return _.EventCourseID;
    });
  });
}

function getRegisteredAthletesForEventCallback(_ref7) {
  var raceId = _ref7.raceId;
  var eventCourseIds = _ref7.eventCourseIds;
  var timeoutOpts = _ref7.timeoutOpts;

  var host = (0, _Configure.getValue)('ATHLINKS_API_HOST');
  var startListStreams = eventCourseIds.map(function (_) {
    return (0, _FetchPeon.doFetch)(host + '/Events/Race/Api/' + raceId + '/StartList/' + _, null, true, timeoutOpts);
  });

  if (startListStreams.length == 0) {
    return _rx.Observable.just({
      isLoading: false,
      racers: []
    });
  }

  return _rx.Observable.combineLatest(startListStreams).map(function (startLists) {
    var racerIdsInList = {};
    var uniqueRacers = [];

    startLists.forEach(function (startList) {
      var racerList = startList.Result && startList.Result.RacerList && startList.Result.RacerList.length > 0 ? startList.Result.RacerList[0] : [];

      racerList.forEach(function (racer) {
        if (!racerIdsInList[racer.RacerId]) {
          racerIdsInList[racer.RacerId] = true;
          uniqueRacers.push(racer);
        }
      });
    });

    return _bastetjs.utils.entityDecoder.decode({
      isLoading: false,
      racers: uniqueRacers.sort(function (a, b) {
        return a.DisplayName.toLowerCase() < b.DisplayName.toLowerCase() ? -1 : 1;
      })
    });
  });
}

/**
 * @param {int} raceId
 * @param {array} eventCourseIds
 * @param {object|null} timeoutOpts Optional doFetch timeout object.
 * @see FetchPeon.doFetch.
 */
function getRegisteredAthletesForEvent(_ref8) {
  var raceId = _ref8.raceId;
  var eventCourseIds = _ref8.eventCourseIds;
  var timeoutOpts = _ref8.timeoutOpts;

  return (0, _RetryHelper.retryHelper)('athletes', getRegisteredAthletesForEventCallback, {
    raceId: raceId, eventCourseIds: eventCourseIds, timeoutOpts: timeoutOpts
  });
}

function getRegistrationOptions(_ref9) {
  var eventId = _ref9.eventId;
  var athlinksId = _ref9.athlinksId;

  var id = eventId || athlinksId;
  var streamId = 'GetRegistrationOptions' + (eventId ? '-' : 'WithAthlinksId-') + id;

  var nowThen = Date.now() / 1000;
  var term = eventId ? { event_id: id } : { athlinks_id: id };

  return _ErosApi.ErosApi.query(streamId, 'reg_option/ctlive/_search', {
    _source: ['reg_option_id', 'event_id', 'race_name', 'name', 'pref_distance_unit', 'course_distance', 'price', 'start_epoch', 'end_epoch', 'closing_epoch', 'show_reg_option'],
    size: 50,
    sort: [{ price: { order: 'desc' } }, { course_distance: { order: 'desc' } }],
    query: {
      filtered: {
        query: { match_all: {} },
        filter: {
          or: [{ and: [{ term: term }, { term: { start_epoch: 0 } }, { term: { end_epoch: 0 } }] }, { and: [{ term: term }, { range: { start_epoch: { lte: nowThen } } }, { range: { end_epoch: { gte: nowThen } } }] }]
        }
      }
    }
  }).map(function (msg) {
    if ('isLoading' in msg && msg.isLoading) {
      return msg;
    }

    var options = (msg.hits || []).map(function (hit) {
      var distance = _distanceConverter2.default.getDistanceFromCTLiveRace(hit.pref_distance_unit, hit.course_distance);

      return {
        regOptionId: hit.reg_option_id,
        eventId: hit.event_id,
        raceName: hit.race_name,
        regOptionName: hit.name,
        distance: distance.displayValue,
        price: hit.price,
        startTime: hit.start_epoch,
        endTime: hit.end_epoch,
        closingTime: hit.closing_epoch,
        showRegOption: hit.show_reg_option
      };
    });

    return _bastetjs.utils.entityDecoder.decode({ options: options });
  });
}

function getUnhiddenRegOptions(_ref10) {
  var eventId = _ref10.eventId;
  var athlinksId = _ref10.athlinksId;

  return getRegistrationOptions({ eventId: eventId, athlinksId: athlinksId }).map(function (msg) {
    var unhidden = msg.options.filter(function (_) {
      return _.showRegOption === true;
    });
    return { options: unhidden || [] };
  });
}

// For testing
var EventsNoble = exports.EventsNoble = {
  getLeastFutureEventByMasterId: getLeastFutureEventByMasterId,
  getLatestEventByMasterId: getLatestEventByMasterId,
  getAllEventsByMasterId: getAllEventsByMasterId,
  getRegistrationOptions: getRegistrationOptions,
  getUnhiddenRegOptions: getUnhiddenRegOptions
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/EventsNoble.js
// module id = 173
// module chunks = 0